var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'host.view.version', params: {vid: _vm.host.versionId}}},domProps:{"textContent":_vm._s(_vm.host.name)}})}
var staticRenderFns = []

export { render, staticRenderFns }